export default function() {
  if (process.client) {
    const existing = document.getElementById('custom-gtag');
    if (existing) return;

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('consent', 'default', {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    });

    const script = document.createElement('script');
    script.id = 'custom-gtag';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }
}
